export default __webpack_public_path__ + "static/media/Sandals of the Haunter in the Dark.a9477563.jpg";